import { h } from 'preact';
import { t } from '../../i18n.js';

export default function DataTable({ columns, data, onRowClick }) {
  if (!data || data.length === 0) {
    return <div class="text-center text-muted" style="padding:40px">{t('common.noResults')}</div>;
  }

  return (
    <table class={`data-table ${onRowClick ? 'data-table-clickable' : ''}`}>
      <thead>
        <tr>
          {columns.map(col => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr key={row.id || i} onClick={() => onRowClick && onRowClick(row)}>
            {columns.map(col => (
              <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
